import { Component, ElementRef, Inject, OnInit, Injector} from "@angular/core";
import { NgbActiveModal, NgbModalRef, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';
import { Router } from "@angular/router";
import * as jQuery from "jquery";
import { DataService } from "../../../services/data/data.service";
import { TradeRequestModel } from '../../../model/trade.request.data';
import { Ticket } from '../../tradedeskTabs/orders/tradeskOrdersTab/tradeskOrdersTab.component';
import { AppComponentBase } from "../../../services/AppComponentBase";
import { wizardSaved, chartingSaved, entrysignalsSaved } from "../../scanner/interfaces/scanner.interfaces";


@Component({
    selector: "modal-scandelete",
    template: require('./scanDelete.component.html'),
    styles: [require('./scanDelete.component.css')]
})

export class scanDeleteModalComponent extends AppComponentBase implements OnInit {
    ngOnInit (): void {
        throw new Error( "Method not implemented." );
    }

    
  
    constructor(
        private router: Router,
        private fb: FormBuilder,
        public activeModal: NgbActiveModal,
        public dataService: DataService,
        injector: Injector,
    ) {
        super(injector);
    }

    private _key: string = "";
    public get key (): string {
        return this._key;
    }
    public set key ( value: string ) {
        this._key = value;
    }


    private _tab: string = "";
    public get tab (): string {
        return this._tab;
    }
    public set tab ( value: string ) {
        this._tab = value;
    }


    public get selectedItem()
    {

        let selected = this.workspace.savedScansOnePool.find(v=>v.key == this.key);

        return selected;
    }


    public get itemName()
    {
        if(this.selectedItem!=undefined)
        {
            return this.selectedItem.savedData.name
        }
        else
        {
            "N/A";
        }
    }

    public deleteScan()
    {
         this.workspace.savedScansOnePool = this.workspace.savedScansOnePool.filter(v=> v!==this.selectedItem)
         this.workspace.addSavedScan();
         this.activeModal.dismiss()
    }
  

}

export function ShowScanDeleteModal(modalService: NgbModal, key:string , tab?:string){
    let m:NgbModalRef= modalService.open(scanDeleteModalComponent,{
        backdrop: "static",
        size: "sm",
        centered: true, 
        windowClass: "dark-modal"
    });
    let modal = (<scanDeleteModalComponent>m.componentInstance);
    modal.key = key;
    if(tab)
    modal.tab = tab;
}
